import { render, staticRenderFns } from "./BoxesProducts.vue?vue&type=template&id=1c3c82c6&"
import script from "./BoxesProducts.vue?vue&type=script&lang=js&"
export * from "./BoxesProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports